module.exports = __webpack_public_path__ + "img/KSAT25-45-1000-1-btn.7e83605a.png";